import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const generic = () => import('@/views/GenericQueueView.vue')
const files = () => import('@/views/FileBrowserView.vue')

const router = createRouter({
  // Matches Vite `base` (import.meta.env.BASE_URL) — /na/next/ or /next/
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('@/layouts/AppLayout.vue'),
      children: [
        { path: '', name: 'home', component: () => import('@/views/HomeView.vue') },
        { path: 'search', name: 'search', component: () => import('@/views/SearchView.vue') },
        { path: 'billing-queue', name: 'billing-queue', component: () => import('@/views/BillingQueueView.vue') },
        { path: 'uw-queue', name: 'uw-queue', component: () => import('@/views/UwQueueView.vue') },
        {
          path: 'collections-queue',
          name: 'collections-queue',
          component: () => import('@/views/CollectionStoreView.vue'),
        },
        {
          path: 'collection-store',
          name: 'collection-store',
          component: () => import('@/views/CollectionStoreView.vue'),
        },
        { path: 'deposits', name: 'deposits', component: files },
        { path: 'payables', name: 'payables', component: files },
        { path: 'billing-titles', name: 'billing-titles', component: generic },
        { path: 'inbound-trades', name: 'inbound-trades', component: generic },
        {
          path: 'jacket-store',
          name: 'jacket-store',
          component: () => import('@/views/JacketStoreView.vue'),
        },
        {
          path: 'document-viewer',
          name: 'document-viewer',
          component: () => import('@/views/DocumentViewerView.vue'),
          meta: { title: 'Document' },
        },
        { path: 'billing-main', name: 'billing-main', component: generic },
        { path: 'writeoffs', name: 'writeoffs', component: generic },
        { path: 'writeoffs/voluntary', name: 'writeoffs-voluntary', component: generic },
        { path: 'payoffs', name: 'payoffs', component: generic },
        {
          path: 'payoffs/requests',
          name: 'payoffs-requests',
          component: () => import('@/views/PayoffRequestsView.vue'),
        },
        { path: 'audit-log', name: 'audit-log', component: generic },
        {
          path: 'deal-audit',
          name: 'deal-audit',
          component: () => import('@/views/DealAuditView.vue'),
          meta: { title: 'Deal Audit' },
        },
        { path: 'insurance', name: 'insurance', component: generic },
        { path: 'auction/pending', name: 'auction-pending', component: generic },
        { path: 'auction/salelist', name: 'auction-salelist', component: generic },
        {
          path: 'nasti/in-transit',
          name: 'nasti-in-transit',
          component: () => import('@/views/InTransitStoreView.vue'),
          meta: { title: 'In Transit Store' },
        },
        { path: 'nasti/inventory', name: 'nasti-inventory', component: generic },
        { path: 'nasti/units', name: 'nasti-units', component: generic },
        {
          path: 'title-requests',
          name: 'title-requests',
          component: () => import('@/views/TitleRequestsView.vue'),
        },
        { path: 'gap/upper', name: 'gap-upper', component: generic },
        { path: 'gap/lower', name: 'gap-lower', component: generic },
        {
          path: 'gap/cancel',
          name: 'gap-cancel',
          component: () => import('@/views/GapCancelView.vue'),
        },
        { path: 'deadrow/pending', name: 'deadrow-pending', component: generic },
        { path: 'deadrow/salelist', name: 'deadrow-salelist', component: generic },
        { path: 'billing-refunds', name: 'billing-refunds', component: generic },
        { path: 'titles-not-transferred', name: 'titles-not-transferred', component: generic },
        { path: 'no-title-receipt', name: 'no-title-receipt', component: generic },
        { path: 'salesmen', name: 'salesmen', component: generic },
        { path: 'insurance/disputes', name: 'insurance-disputes', component: generic },
        { path: 'nasti/checkout', name: 'nasti-checkout', component: generic },
        { path: 'nasti/asl-new', name: 'nasti-asl-new', component: generic },
        { path: 'writeoffs/vehicle', name: 'writeoffs-vehicle', component: generic },
        { path: 'writeoffs/accelerated', name: 'writeoffs-accelerated', component: generic },
        { path: 'writeoffs/involuntary', name: 'writeoffs-involuntary', component: generic },
        { path: 'writeoffs/completed', name: 'writeoffs-completed', component: generic },
        { path: 'writeoffs/title-clerk', name: 'writeoffs-title-clerk', component: generic },
        { path: 'payoffs/accounting', name: 'payoffs-accounting', component: generic },
        { path: 'payoffs/title-upper', name: 'payoffs-title-upper', component: generic },
        { path: 'payoffs/title-lower', name: 'payoffs-title-lower', component: generic },
        { path: 'gap/archive', name: 'gap-archive', component: generic },
        { path: 'bulk-jobs', name: 'bulk-jobs', component: generic },
        { path: 'bulk-upload', name: 'bulk-upload', component: () => import('@/views/BulkUploadView.vue') },
        { path: 'writeoffs/tenday', name: 'writeoffs-tenday', component: generic },
        { path: 'writeoffs/repo', name: 'writeoffs-repo', component: generic },
        { path: 'writeoffs/pending-sale', name: 'writeoffs-pending-sale', component: generic },
        { path: 'writeoffs/repo-processing', name: 'writeoffs-repo-processing', component: generic },
        { path: 'writeoffs/underwriting', name: 'writeoffs-underwriting', component: generic },
        { path: 'writeoffs/archive', name: 'writeoffs-archive', component: generic },
        { path: 'payoffs/archive', name: 'payoffs-archive', component: generic },
        { path: 'auction/sold', name: 'auction-sold', component: generic },
        { path: 'auction/archive', name: 'auction-archive', component: generic },
        { path: 'auction/reorder', name: 'auction-reorder', component: generic },
        { path: 'nasti/archive', name: 'nasti-archive', component: generic },
        { path: 'nasti/special', name: 'nasti-special', component: generic },
        { path: 'nasti/asload', name: 'nasti-asload', component: generic },
        { path: 'rejects', name: 'rejects', component: generic },
        { path: 'credit-disputes', name: 'credit-disputes', component: generic },
        { path: 'underwriting/rejects', name: 'underwriting-rejects', component: generic },
        { path: 'nasti/lot-assignment', name: 'nasti-lot-assignment', component: generic },
        { path: 'nasti/wholesale', name: 'nasti-wholesale', component: generic },
        { path: 'nasti/purchasing', name: 'nasti-purchasing', component: generic },
        { path: 'nasti/shop', name: 'nasti-shop', component: generic },
        { path: 'nasti/list-all', name: 'nasti-list-all', component: generic },
        { path: 'nasti/payments', name: 'nasti-payments', component: generic },
        { path: 'giveaways', name: 'giveaways', component: generic },
        { path: 'sales/lot', name: 'sales-lot', component: generic },
        { path: 'sales/commission', name: 'sales-commission', component: generic },
        { path: 'billing/checks', name: 'billing-checks', component: generic },
        { path: 'jacket-files', name: 'jacket-files', component: generic },
        { path: 'payoffs/title-report', name: 'payoffs-title-report', component: generic },
        {
          path: 'reports/title-pull',
          name: 'reports-title-pull',
          component: () => import('@/views/ExternalReportView.vue'),
          meta: { reportKey: 'title-pull' },
        },
        { path: 'operatorq', name: 'operatorq', component: generic },
        { path: 'commission', name: 'commission', component: generic },
        { path: 'commission/mgr', name: 'commission-mgr', component: generic },
        { path: 'buyers', name: 'buyers', component: generic },
        { path: 'customers', name: 'customers', component: generic },
        { path: 'writeoffs/first-review', name: 'writeoffs-first-review', component: generic },
        {
          path: 'wallboard',
          name: 'wallboard',
          component: () => import('@/views/WallboardLiveView.vue'),
        },
        { path: 'pttracker', name: 'pttracker', component: generic },
        { path: 'lists/collections-category', name: 'lists-collections-category', component: generic },
        { path: 'ops', name: 'ops', component: () => import('@/views/OpsDashboardView.vue') },
        { path: 'ledger', name: 'ledger', component: () => import('@/views/LedgerView.vue') },
        {
          path: 'classic/:menuId',
          name: 'classic-plugin',
          component: () => import('@/views/ClassicPluginView.vue'),
          meta: { title: 'Classic plugin' },
        },
        {
          path: 'admin/users',
          name: 'admin-users',
          component: () => import('@/views/admin/UsersView.vue'),
          meta: { permission: 'users.read' },
        },
        {
          path: 'admin/groups',
          name: 'admin-groups',
          component: () => import('@/views/admin/GroupsView.vue'),
          meta: { permission: 'groups.read' },
        },
        {
          path: 'admin/menus',
          name: 'admin-menus',
          component: () => import('@/views/admin/MenusView.vue'),
          meta: { permission: 'menus.read', platform: true },
        },
        {
          path: 'admin/org-menus',
          name: 'admin-org-menus',
          component: () => import('@/views/admin/OrgMenusView.vue'),
          meta: { permission: 'menus.read' },
        },
        {
          path: 'admin/plugins',
          name: 'admin-plugins',
          component: () => import('@/views/admin/PluginsView.vue'),
          meta: { permission: 'menus.read', platform: true },
        },
        {
          path: 'admin/tenants',
          name: 'admin-tenants',
          component: () => import('@/views/admin/TenantsView.vue'),
          meta: { permission: 'tenants.read', platform: true },
        },
        {
          path: 'admin/settings',
          name: 'admin-settings',
          component: () => import('@/views/admin/SettingsView.vue'),
          meta: { permission: 'admin.access' },
        },
        {
          path: 'admin/builder',
          name: 'admin-builder',
          component: () => import('@/views/admin/BuilderView.vue'),
          // Platform default; granted tenants/users use builder.access
          meta: { permission: 'builder.access' },
        },
        {
          path: 'admin/cron',
          name: 'admin-cron',
          component: () => import('@/views/admin/CronView.vue'),
          meta: { permission: 'platform.access', platform: true },
        },
        {
          path: 'app/:code',
          name: 'custom-app',
          component: () => import('@/views/CustomAppView.vue'),
          meta: { title: 'App view' },
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.meta.public) {
    if (auth.isAuthenticated && to.name === 'login') {
      return { name: 'home' }
    }
    return true
  }

  if (!auth.isAuthenticated) {
    const ok = await auth.fetchMe()
    if (!ok) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }
  }

  if (to.meta.platform && !auth.isAdmin && !auth.isPlatform) {
    return { name: 'home' }
  }

  const perm = to.meta.permission as string | undefined
  if (perm) {
    const ok =
      auth.isAdmin ||
      auth.hasPermission(perm) ||
      (perm === 'platform.access' && auth.isPlatform) ||
      (perm === 'builder.access' && auth.isPlatform)
    if (!ok) {
      return { name: 'home' }
    }
  }

  return true
})

export default router
